
import OnePayment from '~/pages/_lang/payment/123payment/_id.vue'
export default OnePayment
